export default __webpack_public_path__ + "static/concorde-centre-ee9e2c7dd473c1fe6809c2cfa05d88fc.png";